export default {
  components: {
    TopBar: {
      baseStyle: {
        h: ["56px", "56px", "65px"],
      },
    },
  },
};
